import { message, PageHeader, Spin, Switch } from "antd";
import axios from "axios";
import React, {Component} from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import polizasDocumentoPdf from "../../../../Pdf/polizasDocumentoPdf";
import { connect } from "react-redux";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class VerPolizasFactura extends Component{
    state = {
        loading: false,
        pdf: null,
        facturaId: this.props.location.state.facturaId,
        polizasId: null,
        detallada: false,
      };

      atras() {
        this.props.history.goBack();
      }

      cargarPolizasId() {
        this.setState({ loading: true });
        axios
          .post(
            "polizas/polizaIdsPorFactura",
            { facturaId: this.state.facturaId, empresaId: this.props.empresaId },
            { headers: this.props.headersToken }
          )
          .then((res) => {
            if (!res.data.polizasId || res.data.polizasId.length === 0) {
              message.warning("Esta factura no tiene pólizas generadas");
              this.setState({ loading: false, polizasId: [] });
              return;
            }
            this.setState({ polizasId: res.data.polizasId }, () => {
              this.cargarPolizas(false);
            });
          });
      }

      cargarPolizas(detallada) {
        if (!this.state.polizasId || this.state.polizasId.length === 0) return;
        this.setState({ loading: true });
        axios
          .post(
            "polizas/datosPolizas",
            { polizasId: this.state.polizasId, empresaId: this.props.empresaId, detallada: !!detallada },
            { headers: this.props.headersToken }
          )
          .then((res) => {
            if (res.data.success !== 2) {
              message.error("Ha sucedido un error y no se cargaron bien las pólizas");
              this.setState({ loading: false });
              return;
            }
            const polizasOrdenadas = [...res.data.polizas].sort(
              (a, b) => new Date(a.poliza.fechaRegistro) - new Date(b.poliza.fechaRegistro)
            );
            const pdf = pdfMake.createPdf(polizasDocumentoPdf({ polizas: polizasOrdenadas }));
            pdf.open({}, window.frames['printPdf']);
            this.setState({ loading: false, pdf, detallada: !!detallada });
          });
      }

      componentDidMount() {
        this.cargarPolizasId();
      }

      onCambiarDetallada(checked) {
        this.setState({ detallada: checked });
        this.cargarPolizas(checked);
      }

    render(){
        return(
            <>
            <PageHeader
             onBack={this.atras.bind(this)}
              title="Pólizas de la Factura"
              extra={[
                <span key="detallada" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span>Detallada</span>
                  <Switch
                    checked={this.state.detallada}
                    onChange={this.onCambiarDetallada.bind(this)}
                    loading={this.state.loading}
                  />
                </span>
              ]}
              style={{
                border: "1px solid rgb(235, 237, 240)",
                backgroundColor: "white",
                marginBottom: 10,
              }}
            />
            <div className="card-background" style={{ paddingTop: 5 }}>
                <Spin spinning={this.state.loading}>
                    <iframe title={'documentos'} style={{ width: '100%', height: '70vh' }} id="printPdf" name="printPdf"/>
                </Spin>
            </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
    };
  };

export default connect(mapStateToProps)(VerPolizasFactura);
